// /app/frontend/src/context/AuthContext.js
import { useContext } from 'react';
import { AuthContext } from '../App';

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthContext.Provider');
  }
  return context;
}
